import { PostModel } from '@/features/blog/types/models/post.model'
import React from 'react'
import { Post } from '../post'
import { useTranslations } from 'next-intl'

type Props = {
  posts: PostModel[]
}
export const PostList: React.FC<Props> = ({ posts }) => {
  const t = useTranslations()
  if (!posts.length) {
    return (
      <div className='py-10 text-center text-gray-500'>{t('blog.noPosts')}</div>
    )
  }
  return (
    <ul className='grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3'>
      {posts.map(post => (
        <li key={post.id} className='h-full'>
          <Post className='flex h-full flex-col' {...post} />
        </li>
      ))}
    </ul>
  )
}
